import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Badge, Button, Card, CardBody, CardSubtitle, CardText, Col, FormGroup, Input, Modal, ModalBody, Progress, Row, Spinner } from 'reactstrap'
import { Icon, RSelect } from '../../../../../components/Component';
import ToastExample from '../../../../../helpers/toast';
import Content from '../../../../../layout/content/Content';
import Head from '../../../../../layout/head/Head';
import { acceptOrder, assignDeliveryGuyToOrder, cancelOrder, getOrderDeliveryPartners, getSingleOrder, updateOrderStatus } from '../../../../../redux/admin/order/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../../redux/common/actions';
import moment from 'moment'
import fastDelivery from '../../../../../assets/fast-delivery-white.svg';
import { ColorRing } from 'react-loader-spinner';

function SingleOrder() {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(getSingleOrder(id)).then((response) => {
            if (response.payload.success) {
                dispatch(getOrderDeliveryPartners(id)).then((response) => {
                    if (response.payload) {
                        setLoading(false)
                    } else {
                        setLoading(false)
                    }
                })
            }
        })
    }, []);

    const getSelectors = (state) => ({
        single_order: state.order.single_order,
        order_delivery_partners: state.order.order_delivery_partners,
        order_log: state.order.order_log,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });
    const { single_order, order_log, order_delivery_partners, form_loading, form_submission_status } = useSelector(getSelectors);
    const acceptTheOrder = () => {
        dispatch(nonActiveFormSubmissionStatus());
        dispatch(openFormLoading())
        const data = new FormData();
        data.append('id', single_order?.id);
        dispatch(acceptOrder(data));
    }
    const changeStatustoChefCooking = () => {
        dispatch(nonActiveFormSubmissionStatus());
        dispatch(openFormLoading())
        const data = new FormData();
        data.append('id', single_order?.id);
        data.append('order_status_id', 3)
        dispatch(updateOrderStatus(data))
    }
    const changeStatustoPickUp = () => {
        dispatch(nonActiveFormSubmissionStatus());
        dispatch(openFormLoading())
        const data = new FormData();
        data.append('id', single_order?.id);
        data.append('order_status_id', 4)
        dispatch(updateOrderStatus(data))
    }
    const completeTheOrder = () => {
        dispatch(nonActiveFormSubmissionStatus());
        dispatch(openFormLoading())
        const data = new FormData();
        data.append('id', single_order?.id);
        data.append('order_status_id', 7)
        dispatch(updateOrderStatus(data))
    }
    //modal
    const [modal, setModal] = useState({ cancel: false, });
    const openCancelModal = () => {
        dispatch(nonActiveFormSubmissionStatus());
        setModal({ cancel: true });
    }
    const onFormCancel = () => {
        setModal({ cancel: false });
        setCancelData('');
    };

    const cancelTheOrder = () => {
        dispatch(openFormLoading())
        const data = new FormData();
        data.append('id', single_order?.id);
        if (cancelData?.reason === "OTHER") {
            data.append('cancellation_reason', cancelData?.other_reason)
        } else {
            data.append('cancellation_reason', cancelData?.reason)
        }
        if (modal.cancel) {
            dispatch(cancelOrder(data))
        }
    }

    const canceloptions = [
        { value: "Items Not Available", label: "Items Not Available" },
        { value: "Payment Issue", label: "Payment Issue" },
        { value: "Wrong Delivery Address", label: "Wrong Delivery Address" },
        { value: "Restaurant Changed", label: "Restaurant Changed" },
        { value: "Restaurant Closed", label: "Restaurant Closed" },
        { value: "Delay from Restaurant", label: "Delay from Restaurant" },
        { value: "Delay by Delivery", label: "Delay by Delivery" },
        { value: "OTHER", label: "Other Reasons" },
    ]
    const [cancelData, setCancelData] = useState({ reason: '', other_reason: '' });
    const [cancelInput, setCancelInput] = useState(false);

    const handleInput = (val) => {
        setCancelData({ ...cancelData, reason: val });
        if (val === "OTHER") {
            setCancelInput(true);
        } else {
            setCancelInput(false);
        }
    }

    //delivery guy
    const [deliveryGuy, setDeliveryGuy] = useState(single_order?.delivery_guy_detail_id);
    const [deliveryUpdate, setDeliveryUpdate] = useState(false);
    const deliveryguys = order_delivery_partners?.map((partner) => (
        { value: partner.id, label: partner?.user?.name }
    ));


    const assignDeliveryGuy = () => {
        if (deliveryGuy) {
            setDeliveryUpdate(true);
            dispatch(openFormLoading())
            const data = new FormData();
            data.append('order_id', single_order?.id);
            data.append('delivery_guy_detail_id', deliveryGuy);
            dispatch(assignDeliveryGuyToOrder(data))
        } else {
            document.getElementById('nodelivery').innerHTML = '* Select a Delivery Guy.....';
        }
    }

    const [showToast, setShowToast] = useState(false);   //toast state
    useEffect(() => {
        if (modal.cancel == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getSingleOrder(id));
                setModal({ cancel: false });
                setCancelInput(false);
                setShowToast(true);
            }, 300);
            setTimeout(() => {
                setShowToast(false);
            }, 2000);
        } else if (form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                setDeliveryUpdate(false)
                dispatch(getSingleOrder(id));
                setShowToast(true);
            }, 300);
            setTimeout(() => {
                setShowToast(false);
            }, 2000);
        }

    }, [form_loading, modal, form_submission_status]);

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="View Order"></Head>
                    <Content>
                        <ToastExample
                            show={showToast}
                        />
                        <Row>

                            {/* customer */}
                            <Col md="4">
                                <Card className="">
                                    <CardBody className="card-inner">
                                        <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                            <div className='d-flex justify-content-between'>
                                                <div>
                                                    <Icon name="user-list" className='mr-1'></Icon>
                                                    Customer
                                                </div>
                                                <a href={`http://maps.google.com/?q=${single_order?.latitude},${single_order?.longitude}`} target='_blank'>
                                                    <Badge color='dark'>
                                                        View Location
                                                    </Badge>
                                                </a>
                                            </div>
                                        </CardSubtitle>
                                        <CardText className='d-flex flex-column ml-2'>
                                            <span>
                                                <Icon name="user-fill" className='mr-1' style={{ color: '#8094ae' }}></Icon> {single_order?.user?.name}
                                            </span>
                                            <span>
                                                <Icon name="call" className='mr-1' style={{ color: '#8094ae' }}></Icon> {single_order?.user?.phone}
                                            </span>
                                            <div className='d-flex'>
                                                <Icon name="map-pin" className='mr-1 mt-1' style={{ color: '#8094ae' }}></Icon>
                                                <div>
                                                    {single_order?.address}
                                                </div>
                                            </div>
                                            <span>
                                                <Icon name="location" className='mr-1' style={{ color: '#8094ae' }}></Icon>
                                                {single_order?.landmark}
                                            </span>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                            {/* store */}
                            <Col md="3">
                                <Card className="">
                                    <CardBody className="card-inner">
                                        <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                            <Icon name="building" className='mr-1'></Icon>  Store
                                        </CardSubtitle>
                                        <CardText className='d-flex flex-column ml-2'>
                                            <span>
                                                <Icon name="info-fill" className='mr-1' style={{ color: '#8094ae' }}></Icon> {single_order?.store?.name}
                                            </span>
                                            <span>
                                                <Icon name="call" className='mr-1' style={{ color: '#8094ae' }}></Icon>  {single_order?.store?.phone}
                                            </span>
                                            <span>
                                                <Icon name="map-pin" className='mr-1' style={{ color: '#8094ae' }}></Icon>  {single_order?.store?.address}
                                            </span>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                            {/* progress bar */}
                            <Col md="5">
                                <Card className="">
                                    <CardBody className="card-inner">
                                        <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                            <Icon name="package" className='mr-1'></Icon>  Order <Badge color='outline-primary'>{single_order?.unique_order_id}</Badge>
                                        </CardSubtitle>
                                        <CardText className='ml-2 d-flex flex-column'>
                                            <div className='text-capitalize mt-1'>
                                                <Badge>{single_order?.order_status?.name}</Badge>
                                            </div>
                                            <div className='mt-2'>
                                                {single_order?.order_status_id == 1 ? (
                                                    <Progress animated color="warning" value="10" />
                                                ) : single_order?.order_status_id == 2 ? (
                                                    <Progress animated color="success" value="20" />
                                                ) : single_order?.order_status_id == 3 ? (
                                                    <Progress animated color="success" value="30" />
                                                ) : single_order?.order_status_id == 4 ? (
                                                    <Progress animated color="success" value="50" />
                                                ) : single_order?.order_status_id == 5 ? (
                                                    <Progress animated color="success" value="70" />
                                                ) : single_order?.order_status_id == 6 ? (
                                                    <Progress animated color="success" value="85" />
                                                ) : single_order?.order_status_id == 7 ? (
                                                    <Progress animated color="success" value="100" />
                                                ) : single_order?.order_status_id == 8 ? (
                                                    <Progress animated color="danger" value="100" />
                                                ) :
                                                    <Progress value="0" />
                                                }
                                                <span>
                                                    <Icon name="cart-fill"></Icon>
                                                </span>
                                            </div>
                                            <span className='mt-1'>
                                                <Icon name="wallet" className='mr-1' style={{ color: '#8094ae' }}></Icon> {single_order?.payment_mode}
                                            </span>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            {/* bill */}
                            <Col md="8" className='mt-2'>
                                <Card className="">
                                    <CardBody className="card-inner">
                                        <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                            <div className='d-flex justify-content-between'>
                                                <div>
                                                    <Icon name="list" className='mr-1'></Icon> Bill Details
                                                </div>
                                                <div>
                                                    {single_order?.is_express ?
                                                        <span className="badge badge-success d-flex align-items-center" >
                                                            <img src={fastDelivery} style={{ width: '20px' }} alt='Limtzo' /> <span style={{ paddingLeft: '2px' }}> Express Delivery</span>
                                                        </span>
                                                        : null}
                                                </div>
                                            </div>
                                        </CardSubtitle>
                                        <CardText className='d-flex flex-column ml-2'>
                                            <div className='d-flex justify-content-between mt-1'>
                                                <div className='d-flex flex-column' style={{ color: '#8094ae', fontSize: '12px' }}>
                                                    <span>
                                                        <Badge color='outline-primary'>{single_order?.unique_order_id}</Badge>
                                                    </span>
                                                </div>
                                                <div className='text-capitalize'>
                                                    <Badge>{single_order?.order_status?.name}</Badge>
                                                </div>
                                            </div>
                                            <table className="table table-responsive-lg table-borderless mt-2  text-right">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th scope="col">Product</th>
                                                        <th scope="col">Quantity</th>
                                                        <th scope="col">Price</th>
                                                        <th scope="col">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {single_order?.order_items?.length > 0 ?
                                                        <>
                                                            {single_order?.order_items?.map((item, index) => (
                                                                <>
                                                                    <tr>
                                                                        <td>{index + 1}{"."}</td>
                                                                        <td>{item?.name}</td>
                                                                        {item?.order_item_addons?.length > 0 ?
                                                                            <>
                                                                                <td>--</td>
                                                                                <td>--</td>
                                                                                <td>--</td>
                                                                            </> : <>
                                                                                <td>{item?.quantity}</td>
                                                                                <td>{parseFloat(item?.price)?.toFixed(2)}</td>
                                                                                <td>{parseFloat(item?.price * item?.quantity)?.toFixed(2)}</td>
                                                                            </>
                                                                        }
                                                                    </tr>
                                                                    {item?.order_item_addons?.length > 0 &&
                                                                        item?.order_item_addons?.length > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td colspan='5'>
                                                                                    <div className="nk-divider divider  my-1"></div>
                                                                                </td>
                                                                            </tr>
                                                                            {/* <tr style={{ fontSize: '12px', color: '#526484', fontWeight: '550' }}>
                                                                        <td></td>
                                                                        <td>Addon</td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr> */}
                                                                            {item?.order_item_addons?.filter((addon, index) => (addon.type === 'MULTIPLE'))?.map((addon, index) => (
                                                                                <>
                                                                                    <tr style={{ fontSize: '12px' }}>
                                                                                        <td></td>
                                                                                        <td>{addon?.addon_name}</td>
                                                                                        <td>{addon?.addon_quantity}</td>
                                                                                        <td>{addon.addon_price}</td>
                                                                                        <td>{parseFloat(addon.addon_price * addon?.addon_quantity)?.toFixed(2)}</td>
                                                                                    </tr>
                                                                                </>
                                                                            ))}
                                                                            {item?.order_item_addons?.filter((addon) => (addon.type === 'SINGLE'))?.map((addon, index) => (
                                                                                <>
                                                                                    <tr style={{ fontSize: '12px' }}>
                                                                                        <td></td>
                                                                                        <td>{addon?.addon_name}</td>
                                                                                        <td>{addon?.addon_quantity}</td>
                                                                                        <td>{addon.addon_price}</td>
                                                                                        <td>{parseFloat(addon.addon_price * addon?.addon_quantity)?.toFixed(2)}</td>
                                                                                    </tr>
                                                                                </>
                                                                            ))}
                                                                        </>
                                                                    }
                                                                    <tr>
                                                                        <td colspan='5'>
                                                                            <div className="nk-divider divider my-1"></div>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            ))}
                                                        </>
                                                        : ""}
                                                </tbody>
                                            </table>
                                            <div className="nk-divider divider sm"></div>
                                            <div className="d-flex flex-column align-content-center justify-content-center align-items-end mx-1">
                                                <div className="">
                                                    {single_order?.order_comment && single_order?.order_comment != 'null' &&
                                                        <div className="d-flex flex-row text-danger justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                            <div className="flex-grow-1">
                                                                <label className="col-form-label p-0 fs-8">Order Comment :</label>
                                                            </div>
                                                            <div className="text-right flex-grow-1 fs-8 w-75px">
                                                                {single_order?.order_comment}
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="d-flex flex-row justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label p-0 fs-8">Sub Total :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 fs-8 w-75px">
                                                            <span style={{ fontSize: '18px', paddingRight: '2px' }}>-</span> INR. {parseFloat(single_order?.sub_total)?.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-row justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label fs-8" style={{ padding: '0px 8px 0px 0px' }}>Tax & Other charges :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 fs-8 w-75px">
                                                            <span style={{ fontSize: '18px', paddingRight: '2px' }}>-</span> INR. {(parseFloat(single_order?.surge_fee ?? 0) + parseFloat(single_order?.tax ?? 0) + parseFloat(single_order?.convenience_fee ?? 0)).toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-row justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label p-0 fs-8">Store Charge :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 fs-8 w-75px">
                                                            <span style={{ fontSize: '18px', paddingRight: '2px' }}>-</span>  INR. {parseFloat(single_order?.store_charges)?.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    {single_order?.coupon_amount > 0 ? (
                                                        <div className="d-flex flex-row justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                            <div className="flex-grow-1">
                                                                <label className="col-form-label p-0 fs-8">Coupon Discount :</label>
                                                            </div>
                                                            <div className="text-right flex-grow-1 fs-8 w-75px">
                                                                <span style={{ fontSize: '18px', paddingRight: '2px' }}>-</span>  INR. {parseFloat(single_order?.coupon_amount)?.toFixed(2)}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    <div className="d-flex flex-row justify-content-between align-items-center mt-2" style={{ color: '#121212', fontWeight: '530', fontSize: '15px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label p-0">Total :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 w-75px">
                                                            INR. {(parseFloat(single_order?.total) - parseFloat(single_order?.delivery_charge))?.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-row justify-content-between align-items-center mt-2" style={{ fontSize: '13px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label p-0 fs-8">Delivery Charge :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 fs-8 w-75px">
                                                            <span style={{ fontSize: '18px', paddingRight: '2px' }}>+</span>   INR. {parseFloat(single_order?.delivery_charge)?.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    {single_order?.walletamount > 0 ?
                                                        <div className="d-flex flex-row justify-content-between align-items-center" style={{ fontSize: '13px' }}>
                                                            <div className="flex-grow-1">
                                                                <label className="col-form-label p-0 fs-8">Wallet Redeemed :</label>
                                                            </div>
                                                            <div className="text-right flex-grow-1 fs-8 w-75px">
                                                                <span style={{ fontSize: '18px', paddingRight: '2px' }}>-</span>  INR. {parseFloat(single_order?.walletamount)?.toFixed(2)}
                                                            </div>
                                                        </div>
                                                        : null}
                                                    {single_order?.payable > 0 ?
                                                        <div className="d-flex flex-row justify-content-between align-items-center mt-2" style={{ color: '#121212', fontWeight: '530', fontSize: '15px' }}>
                                                            <div className="flex-grow-1">
                                                                <label className="col-form-label p-0">Payable :</label>
                                                            </div>
                                                            <div className="text-right flex-grow-1 w-75px">
                                                                INR. {parseFloat(single_order?.payable)?.toFixed(2)}
                                                            </div>
                                                        </div>
                                                        : null}
                                                </div>
                                            </div>
                                            <div className="nk-divider divider sm"></div>
                                            <div className="d-flex flex-column align-content-center justify-content-center align-items-end mx-1">
                                                <div className="">
                                                    <div className="d-flex flex-row justify-content-between align-items-center" style={{ color: '#121212', fontWeight: '600', fontSize: '15px' }}>
                                                        <div className="flex-grow-1">
                                                            <label className="col-form-label p-0">(Total Order Price) Net Total :</label>
                                                        </div>
                                                        <div className="text-right flex-grow-1 w-75px">
                                                            INR. {parseFloat(single_order?.total)?.toFixed(2)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="4">
                                {/* delivery guy */}
                                <Row className='mt-2' >
                                    <Card className="flex-grow-1">
                                        <CardBody className="card-inner">
                                            <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                                <Icon name="account-setting-alt" className='mr-1'></Icon>Manage Delivery Guy
                                            </CardSubtitle>
                                            <CardText className='d-flex flex-column ml-1'>
                                                <div className="">
                                                    <RSelect
                                                        options={deliveryguys}
                                                        onChange={(e) => setDeliveryGuy(e.value)}
                                                        defaultValue={deliveryguys?.find((guy) => single_order?.accept_delivery?.delivery_guy_detail_id ?
                                                            guy.value === single_order?.accept_delivery?.delivery_guy_detail_id :
                                                            single_order?.delivery_guy_detail_id ? guy.value === single_order?.delivery_guy_detail_id : null
                                                        )}
                                                    />
                                                </div>
                                                <div id='nodelivery' style={{ fontSize: '11px', color: 'red', fontStyle: 'italic' }}></div>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <div className="" style={single_order?.order_status_id == 7 || single_order?.order_status_id == 8 ? { display: 'none' } : { display: 'block' }}>
                                                        {/* {deliveryUpdate && form_loading ? ( */}
                                                        {form_loading ? (
                                                            <>
                                                                <Button color='primary'>
                                                                    <Spinner size="sm" color="light" />Updating
                                                                </Button>
                                                            </>
                                                        ) : (
                                                            <Button color='primary' onClick={() => { assignDeliveryGuy() }}><Icon name="folder-check" className='mr-1' />Update</Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Row>

                                {/* timeline */}
                                <Row className='mt-2' >
                                    <Card className="">
                                        <CardBody className="card-inner">
                                            <CardSubtitle style={{ color: '#526484', fontWeight: '500' }} tag="h6" className="mb-2 ff-base">
                                                <Icon name="truck" className='mr-1'></Icon> Order Activity
                                            </CardSubtitle>
                                            <CardText className='d-flex flex-column ml-1'>
                                                <div className="d-flex justify-content-between">
                                                    {single_order?.order_status_id == 1 ?
                                                        <Button color='success' outline onClick={() => acceptTheOrder()}>
                                                            {!deliveryUpdate && form_loading ? <Spinner size="sm" color="success" /> : <Icon name="check-circle-fill" />}Accept
                                                        </Button>
                                                        : single_order?.order_status_id == 2 ?
                                                            <Button color='success' outline onClick={() => changeStatustoChefCooking()}>
                                                                {!deliveryUpdate && form_loading ? <Spinner size="sm" color="success" /> : <Icon name="clock-fill" />}Chef Cooking
                                                            </Button>
                                                            : single_order?.order_status_id == 3 ?
                                                                <Button color='success' outline onClick={() => changeStatustoPickUp()}>
                                                                    {!deliveryUpdate && form_loading ? <Spinner size="sm" color="success" /> : <Icon name="bell" />}Ready to Pick
                                                                </Button>
                                                                : [4, 5, 6]?.includes(single_order?.order_status_id) ?
                                                                    <Button color='success' outline onClick={() => completeTheOrder()}>
                                                                        {!deliveryUpdate && form_loading ? <Spinner size="sm" color="success" /> : <Icon name="list-check" />}Complete
                                                                    </Button> : ""
                                                    }
                                                    <div className="" style={single_order?.order_status_id == 7 || single_order?.order_status_id == 8 ? { display: 'none' } : { display: 'block' }}>
                                                        <Button color='danger' outline onClick={() => openCancelModal()}><Icon name="cross-circle-fill" />Cancel</Button>
                                                    </div>
                                                </div>
                                                <div className="card-inner">
                                                    <div className="timeline">
                                                        <ul className="timeline-list">
                                                            {order_log?.length > 0 && order_log?.map((log, key) => {
                                                                return (
                                                                    <li className="timeline-item" key={log?.id}>
                                                                        <div className={key == (order_log.length - 1) ? 'timeline-status bg-primary is-outline' : 'timeline-status bg-primary'}></div>
                                                                        <div className="timeline-date">
                                                                            {moment(log?.created_at).format("DD-MMM")}<Icon name="alarm-alt"></Icon>
                                                                        </div>
                                                                        <div className="timeline-data">
                                                                            <h6 className="timeline-title">{log?.description}</h6>
                                                                            <div className="timeline-des">
                                                                                <span className="time">{moment(log?.created_at).format("hh:mm A")}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </Col>
                        </Row>
                    </Content>

                    {/* order status updating modal */}
                    <Modal
                        isOpen={modal.cancel}
                        toggle={() => setModal({ cancel: false })}
                        className="modal-dialog-centered"
                        size='md'
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Cancel Order{" "}<Badge color="outline-primary">{single_order?.unique_order_id}</Badge> ?</h5>
                                <Col md="12" >
                                    <FormGroup>
                                        <label className="form-label">Cancellation Reason</label>
                                        <div className="form-control-wrap">
                                            <RSelect
                                                options={canceloptions}
                                                defaultValue={canceloptions?.find((opt) => (opt.value === cancelData?.reason))}
                                                onChange={val => { handleInput(val.value) }}
                                            />
                                            <div className='mt-2' id='exmple123' style={cancelInput ? { display: "block" } : { display: 'none' }}>
                                                <Input type="text" name="other_reason" placeholder='Enter reason here...' onChange={(e) => { setCancelData({ ...cancelData, other_reason: e.target.value }) }} />
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button
                                                type='button'
                                                color="danger"
                                                className="px-4 btn-block"
                                                onClick={(e) => { e.preventDefault(); cancelTheOrder() }}
                                            >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />Cancelling Order
                                                    </>
                                                ) : (
                                                    <React.Fragment>Cancel Order</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>

    )
}

export default SingleOrder
